import { TokenStore } from "./token-store";
import { AuthProvider, triggerLogout } from "./auth-context";

const tokenStore = new TokenStore();
Object.freeze(tokenStore);

export {
  tokenStore,
  AuthProvider,
  triggerLogout,
};
